import type { JSX } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { withPrefetchedData } from '#src/shared/prefetch';

import { PetitionActionsPageContextProvider, prefetchPageContext } from '#src/app/pages/actions/pageContext';
import type { PetitionActionsPagePrefetchedDataProps } from '#src/app/pages/actions/pageContext';

import { Layout } from '../layout';

import { PetitionActionsErrorHandler } from './PetitionActionsErrorHandler';

export const PetitionActions = withPrefetchedData(
	({ prefetchedData }: PetitionActionsPagePrefetchedDataProps): JSX.Element => {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PetitionActionsPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PetitionActionsErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PetitionActionsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
